module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/sign_me_doc_check-5e21a50dfbc9636d600ddaf442cd6331.svg";